import './NewCollection.css';
import {useEffect, useRef, useState} from "react";
import {fetchNewCollectionBrief} from "../../../../ProductsHandler.js";

export default function NewCollection() {
    const [collectionImages,setCollectionImages] = useState([]);

    const fetchNewCollection = async()=>{
        const data = await fetchNewCollectionBrief();
        if (data) {
            const categories = { rzesy: [], holder: [], peseta: [], rest: [] };

            data.forEach(item => {
                const key = ['rzesy', 'holder', 'peseta'].find(k => item.handle.includes(k)) || 'rest';
                categories[key].push(item);
            });

            const result = [];
            const maxLen = Math.max(
                categories.rzesy.length,
                categories.holder.length,
                categories.peseta.length
            );

            for (let i = 0; i < maxLen; i++) {
                ['rzesy', 'holder', 'peseta'].forEach(key => {
                    if (categories[key][i]) result.push(categories[key][i]);
                });
            }

            result.push(...categories.rest);

            setCollectionImages(result.map(({ id, url }) => ({ id, url })));
        }

    }

    // const redirectImage = (id)=>{
    //     window.location.href=`http://${import.meta.env.VITE_SITE_DOMAIN}/produkt?id=${id}`
    // }

    useEffect(()=>{
       fetchNewCollection();
    },[])

    const redirect = () => {
        window.location.href = `http://${import.meta.env.VITE_SITE_DOMAIN}/produkty?newcollection=true`;
    };

    const [firstImageIndex, setFirstImageIndex] = useState(0);
    const startX = useRef(0);
    const isDragging = useRef(false);

    const manageSlider = (direction) => {
        setFirstImageIndex(prevIndex => {
            if (direction === "prev" && prevIndex > 0) return prevIndex - 1;
            if (direction === "next" && prevIndex < collectionImages.length - 2) return prevIndex + 1;
            return prevIndex;
        });
    };

    const handleMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.clientX || e.touches[0].clientX;
    };

    const handleMouseMove = (e) => {
        if (!isDragging.current) return;
        const currentX = e.clientX || e.touches[0].clientX;
        const difference = startX.current - currentX;

        if (difference > 50) {
            manageSlider("next");
            isDragging.current = false;
        } else if (difference < -50) {
            manageSlider("prev");
            isDragging.current = false;
        }
    };

    const handleMouseUp = () => {
        isDragging.current = false;
    };

    return (
        <div id='new-collection-container'>
            <div id='new-collection-left'>
                <div id='new-collection-labels-container'>
                    <span id='new-collection-label-1'>PRODUKTY<br/> LUME</span>
                    <br />
                    <span id='new-collection-label-2'>Sprawdź, co oferuje Lume</span>
                </div>
                <div id='new-collection-navigation-container'>
                    <div id='new-collection-order-now-bttn' onClick={redirect}>
                        <span>Zamów już teraz</span>
                        <div id='arrow-img'>
                            <img loading="lazy" src='/images/arrow-long-icon.webp' alt="" />

                        </div>
                    </div>
                    <div id='new-collection-navigation-bttns-container'>
                        <div id='new-collection-navigation-left'
                             onClick={() => manageSlider('prev')}
                             className='new-collection-navigation-bttn'
                             >
                            <img loading="lazy" src={firstImageIndex===0 ? '/images/arrow-icon-inactive.webp' : '/images/arrow-icon.webp'} alt="" />

                        </div>
                        <div id='new-collection-navigation-right'
                             onClick={() => manageSlider('next')}
                             className='new-collection-navigation-bttn'>
                            <img loading="lazy" src={firstImageIndex===collectionImages.length-2 ? '/images/arrow-icon-inactive.webp' : '/images/arrow-icon.webp' } alt=""/>
                        </div>
                    </div>
                </div>
            </div>
            <div id='new-collection-right'>
                <div id="slider-container"
                     onMouseDown={handleMouseDown}
                     onMouseMove={handleMouseMove}
                     onMouseUp={handleMouseUp}
                     onMouseLeave={handleMouseUp}
                     onTouchStart={handleMouseDown}
                     onTouchMove={handleMouseMove}
                     onTouchEnd={handleMouseUp}
                     style={{ cursor: 'grab' }}>
                    {collectionImages.map((image, index) => (
                        <div className='collection-image'
                            onClick={()=>redirect()}
                             key={index}
                             style={{transform: `translateX(${firstImageIndex * -100}%)`}}>
                            <img loading="lazy" src={image.url} alt={image.alt || 'Zdjęcie kolekcji'} />

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
